import { useState } from "react";
import { Link } from "react-router-dom";
import { Crown, X, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Renewal nudge: shows when Pro expires within 3 days, or has already expired.
// Dismissible per state (stored in localStorage so it doesn't nag every page).
export default function PremiumExpiryBanner() {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(false);

  if (!user || user === true) return null;
  const expired = user.premium_expired;
  const days = user.premium_days_left;
  const soon = user.is_premium && typeof days === "number" && days <= 3;
  if (!expired && !soon) return null;

  const key = `oxo_pro_banner_${user.premium_until || "x"}_${expired ? "exp" : "soon"}`;
  if (hidden || (typeof window !== "undefined" && localStorage.getItem(key) === "1")) return null;

  const dismiss = () => { localStorage.setItem(key, "1"); setHidden(true); };
  const msg = expired
    ? "Abonamentul tău OXO Pro a expirat. Ai revenit la planul gratuit (max. 3 anunțuri active)."
    : days <= 0
      ? "Abonamentul tău OXO Pro expiră astăzi."
      : `Abonamentul tău OXO Pro expiră în ${days} ${days === 1 ? "zi" : "zile"}.`;

  return (
    <div className={`${expired ? "bg-slate-900" : "bg-amber-500"} text-white`} data-testid="premium-expiry-banner">
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <Crown className={`w-4 h-4 shrink-0 ${expired ? "text-amber-400" : "text-slate-900"}`} />
        <span className={`font-semibold ${expired ? "text-white" : "text-slate-900"}`} data-testid="premium-expiry-msg">{msg}</span>
        <Link
          to="/preturi"
          className={`ml-auto inline-flex items-center gap-1.5 font-bold uppercase tracking-wide text-xs px-4 py-1.5 transition-colors ${expired ? "bg-amber-500 hover:bg-amber-400 text-slate-900" : "bg-slate-900 hover:bg-slate-700 text-white"}`}
          data-testid="premium-expiry-renew"
        >
          {expired ? "Reactivează Pro" : "Reînnoiește"} <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <button onClick={dismiss} className={`shrink-0 ${expired ? "text-white/60 hover:text-white" : "text-slate-900/60 hover:text-slate-900"}`} data-testid="premium-expiry-dismiss" aria-label="Închide">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
